import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";

const FocusLabelsManagerPage = lazy(
  () => import("../components/focusLabels/FocusLabelsManagerPage"),
);

// Connects to data-controller="network-focus-labels-form"
// Intended to be used on a div container inside the network channel settings tabs
export default class extends Controller {
  connect() {
    const container = document.createElement("div");
    this.element.appendChild(container);
    this.root = createRoot(container);
    this.root.render(
      <QueryClientProvider>
        <Suspense fallback={null}>
          <FocusLabelsManagerPage parent={{ type: "network" }} />
        </Suspense>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
